module.exports = __webpack_public_path__ + "static/media/menu-open.fc109e74.svg";